<template>
    <section class="tips">
        <img v-if="info.reverse ? info.value <= 0 : info.value >= 0" src="~static/img/happy.png" alt="图" />
        <img v-else src="~static/img/sad.png" alt="图" />
	    <div class="txt">
	        <h2 v-if="info.title">
	            {{ info.title }}
	            <em :class="{'red' : info.value < 0}">
	                {{ info.value | formatNum }}
	            </em>
	        </h2>
	        <p v-html="info.suggest" :class="{ 'other': !info.title }"></p>
	    </div>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .tips {
        padding-top: 25px;
        border-top: 1px solid #E9EEF0;
        margin-top: 30px;
        height: 78px;
        img {
            width: 37px;
            height: 37px;
            margin-right: 10px;
	        display: inline-block;
	        vertical-align: middle;
        }
	    .txt {
		    display: inline-block;
		    vertical-align: middle;
		    width: 90%;
		    h2 {
			    font-size: 18px;
			    font-weight: normal;
			    width: 100%;
			    margin: 0;
			    em {
				    color: #0CDE65;
				    font-style: normal;
				    &.red {
					    color: #FF4116;
				    }
			    }
		    }
		    p {
			    font-size: 12px;
			    width: 100%;
			    margin: 0;
			    > a {
				    color: #2CA4F7;
				    text-decoration: underline;
			    }
			    &.other {
				    font-size: 13px;
			    }
		    }
	    }
    }
</style>

<script>
    import percentformat from '../../filters/percent-format'

    export default {
	    filters: {
		    percentformat
	    },
        data () {
            return {}
        },
        props: ['info'],
        methods: {
        },
	    filters: {
        	// 负数转化为正数
		    formatNum(num) {
		    	if (num >= 0) {
		    		return '上升了 ' + percentformat(num) + '%';
                } else {
				    return '下降了 ' + percentformat(String(num).replace(/^-+/g, '')) + '%';
			    }
		    }
        }
    }
</script>



// WEBPACK FOOTER //
// Tips.vue?02026eb2